<template>
    <el-dialog
        class="seeoffer-dailog-style"
        title="查看价格"
        v-dialogDrag
        :width="'800px'"
        :visible.sync="seeOfferVisible"
        :before-close="close"
        :append-to-body="true"
    >
        <el-table :data="dataList" height='400px'>
            <el-table-column
                v-for="(item, i) in column"
                :key="i"
                :prop="item.prop"
                :label="item.label"
            ></el-table-column>
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { realTimeBiddingList } from '../../../api/tenderDetails.js';
export default {
    props: {
        seeOfferVisible: {
            type: Boolean,
            default() {
                return false;
            }
        },
        tenderCode: {
            type: String,
            default() {
                return '';
            }
        },
        bidNo: {
            type: String,
            default() {
                return '';
            }
        },
        managementSide: {
            type: Boolean,
            default() {
                return false;
            }
        },
        currentList: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            offerVisible: false,
            biddingsetInterval: null,
            countTimes: '',
            dataList: [],
            column: [
                {
                    label: '供应商',
                    prop: 'supplierName'
                },
                {
                    label: '标段',
                    prop: 'extStr1'
                },
                {
                    label: '总费用',
                    prop: 'lineAmountTotal'
                },
                {
                    label: '当前最低价',
                    prop: 'currentLowestPrice'
                },
                {
                    label: '当前排名',
                    prop: 'currentRank'
                }
            ]
        };
    },
    methods: {
        offerFunc() {
            this.offerVisible = true;
        },
        close() {
            this.$emit('update:seeOfferVisible', false);
        },
        realTimeBiddingListFunc() {
            const par = {
                bidNo: this.bidNo, // 标书编号
                tenderCode: this.tenderCode, // 报价轮次编号
                supplierCode: this.$store.state.supplier ? this.$store.state.supplier.supplierCode : '', // 供应商编码 (管理端不用传该参数， 供应商端必传)
                portal: !this.managementSide // 供应商端传true，管理端传false
            };
            realTimeBiddingList(par).then((res) => {
                if (res && res.code === '0') {
                    this.dataList = res.data || [];
                }
            });
        }
    },
    watch: {
        seeOfferVisible(val) {
            if (val) {
                this.realTimeBiddingListFunc();
            }
        },
        currentList(val) {
            this.dataList = val;
        }
    }
};
</script>
<style lang="less">
.seeoffer-dailog-style {
    .operate-btn {
        margin-bottom: 10px;
    }
    .content-desc-item {
        margin-bottom: 4px;
        width: 33.3%;
        color: #888888;
    }
    .count-down {
        margin-left: 5px;
        color: #FF3300;
        font-size: 20px;
        font-weight: 700;
    }
    .count-box {
        display: flex;
        justify-content: space-between;
    }
}
</style>